export default "__VITE_ASSET__HlYolHGy__"